import { render, staticRenderFns } from "./step.vue?vue&type=template&id=67354320&scoped=true&"
import script from "./step.vue?vue&type=script&lang=js&"
export * from "./step.vue?vue&type=script&lang=js&"
import style0 from "./step.vue?vue&type=style&index=0&id=67354320&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67354320",
  null
  
)

export default component.exports